// do we need to clean storage?
// i remove all non-system props that don't start with "misc:" or "rptCriteria:"
export function validateStorageKey(key, showMessage) {
  const keysByScreen = [
    'resizeRightProps',
    'workspaceCriteriaOpen:',
    'workspaceSearchLeft:',
    'workspaceSearchOpen:',
    'workspaceSearchPosition:',
    'searchFormCurrent',
    'searchEdits',
    'searchSaved',
    'searchWithCriteria', // need to remove
    // 'tableSettings', // disabled for now - id depends on item in some screens
    'tabGroupPrimaryTabs',
    'wo-desktop-msmap',
    'wo-desktop-msmap-overlaysData',
    'map_dynamicLayer',
    'map_showCrew',
    'map_showWarehouse',
    'token_refresh_date_d',
    'loglevel:', // ??
    'rptCriteria:', // for local use
    'misc:', // for local use
    'map_query_layer',
    'map_query_clause',
    'cache_',
    'localStorageCached:',
    'emailPopupTempl:',
    'emailPopupAddrOption:',
    'emailPopupIncludePrintout:',
    'dashboardFilter:',
    'dashboardChartsPreview:',
    'dashboardEdit:',
    'tablePagesize:',
    'is_new_design_p',
    'portal:',
    'queryFilter:',
  ];
  const keysOther = [
    'token',
    'token_d',
    'refreshToken_d',
    'tokenExpires_d',
    'tokenReloading_d',
    'tokenAttempts_d',
    'tokenRequestsQueue_d', // for debugging
    'token_p',
    'refreshToken_p',
    'tokenExpires_p',
    'tokenReloading_p',
    'userID_d', // for debugging
    'userProfile',
    'userMenuFavorites',
    'isMenuClosed',
    'isMenuCustom',
    'menuType',
    'statsEvents',
    'statsTimer',
    'statsReportTime',
    'userStyling',
    'wpYear',
    'systemMessages', // show updates
    'recentClicks_desktop',
    'recentClicks_portal',
    'recentClicks_mobile',
    'recentEvents_desktop',
    'recentEvents_portal',
    'recentEvents_mobile',
    'userProfileWR', // portal
    'userPortalidWR', // portal
    'skey', // portal
    'isRightOpen', // portal
    'wr_list_filter_p', // portal
    'sim_name',
    'fuelDataValidate',
    'woAssetHistDateForm',
    'assetHistDateForm',
    'versionUpdateKey',
    'portalLastTimerTimestamp',
    'HEAT_MAP_LOCAL_STORAGE_KEY',
    'profile',
  ];
  const valid = keysOther.includes(key) || keysByScreen.some(k => key.indexOf(k) === 0);
  if (!valid && showMessage) console.warn('Storage key is not valid:', key, ', check validateStorageKey() in utils/storage.js');

  return valid;
}
export function cleanStorage() {
  // do not clean localstorage for now, it seems to break the mobile
  return;
  let keysOld = Object.keys(global.localStorage);
  keysOld.forEach(d => { if (!validateStorageKey(d)) global.localStorage.removeItem(d); });
  // console.log('clean:', global.localStorage.getToken());
}

export function saveToStorage(key, value) {
  if (value == null) {
    global.localStorage.removeItem(key);
  } else {
    validateStorageKey(key, true);
    if (typeof (value) === 'Object') {
      value = JSON.stringify(value);
    }
    global.localStorage[key] = value;
  }
}

export function loadFromStorage(key) {
  validateStorageKey(key, true);
  return global?.localStorage?.[key] || ((typeof window !== "undefined" && window.localStorage) ? window.localStorage?.[key] : null);
}

function isJsonString(str) {
  try { JSON.parse(str); } catch (e) { return false; }
  return true;
}
export function loadFromStorageJSON(key) {
  validateStorageKey(key, true);
  const res = global.localStorage[key];
  if (isJsonString(res)) return JSON.parse(res);
  return null;
}
export function saveToStorageJSON(key, value) {
  saveToStorage(key, JSON.stringify(value));
}

export async function cached(key, promiseOrFunc) {
  key = 'cache_' + key;
  let data = null;
  if (global.localStorage[key]) {
    try {
      data = JSON.parse(global.localStorage[key]);
    } catch (e) {
      global.localStorage.removeItem(key);
      return cached(key, promiseOrFunc);
    }
  } else {
    let promise = promiseOrFunc;
    if (typeof (promiseOrFunc) === 'function') {
      promise = promiseOrFunc();
    }
    data = await promise;
    global.localStorage[key] = JSON.stringify(data);
  }
  return data;
}

/*
var val = cachedValue("dropDownValue", 2);
cachedValueSave("dropDownValue", 4);
*/
export function cachedValue(key, def) {
  let globalKey = 'localStorageCached:' + key;
  let value = def;
  if (localStorage[globalKey] !== undefined) value = localStorage[globalKey];
  return value;
}
export function cachedValueSave(key, value) {
  let globalKey = 'localStorageCached:' + key;
  localStorage[globalKey] = value;
}

export function localstorageLoadObject(key, def) {
  if (key) {
    let s = global.localStorage[key];
    if (s === undefined) return {};
    try {
      let o = JSON.parse(s);
      return o;
    } catch (e) {
      console.warn('load ' + key + ' error', s);
    }
  }
  return def || {};
}

export function localstorageSaveObject(key, object) {
  let str = object;
  if (typeof (object == 'Object')) {
    str = JSON.stringify(object);
  }
  global.localStorage[key] = str;
}

export function clearSelectedStorage() {
  Object.keys(global.localStorage).forEach(key => {
    if (key.includes('map_')) { global.localStorage.removeItem(key); }
    if (key.includes('misc:')) { global.localStorage.removeItem(key); }
    if (key.includes('searchFormCurrent:')) { global.localStorage.removeItem(key); }
    if (key.includes('searchEdits:')) { global.localStorage.removeItem(key); }
    if (key.includes('searchSaved:')) { global.localStorage.removeItem(key); }
  });
}
